import { connect } from 'react-redux';

import SplitPurchaseProjection from '../components/split-purchase-projection';

const mapStateToProps = ({ purchases, memberships, projections }, props) => {
  let projectedMembership;
  const purchase = purchases.byId[purchases.current];
  let shareAmount = { amountCents: 0, currencyCode: purchase.currencyCode };

  if (props.namespace && projections[props.namespace]) {
    projectedMembership = projections[props.namespace].memberships[memberships.current];
  }

  if (projectedMembership) {
    shareAmount = projectedMembership.shareAmount;
  }

  return {
    shareAmount,
  };
};

export default connect(mapStateToProps)(SplitPurchaseProjection);



// WEBPACK FOOTER //
// ./src/desktop/containers/split-purchase-projection.container.js